
      import ElectronicManual from './electronic-manual.vue'
      import type { App, Plugin } from 'vue'

      export const ElectronicManualPlugin: Plugin = {
        install(app: App) {
          app.component('ElectronicManual', ElectronicManual)
        },
      }
      export { ElectronicManual }
      